import { STANDARD_BRANCH } from '@festina-life/api'
import { assertNotEmpty, dateUtils } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'
import cx from 'classnames'

import type { ConciseChangesetWithBranchKey } from '../../../../uiModels/changesets/types'
import { ConfigurationBranchStatus } from '../../../branchNameWithStatus/ConfigurationBranchStatus'
import { StandardBranchStatus } from '../../../branchNameWithStatus/StandardBranchStatus'

type Props = {
  changeset: ConciseChangesetWithBranchKey
  className: string
}

export const ChangesetAttributes = ({ changeset, className }: Props) => {
  const translate = useTranslate()
  const { branchKey, operations, ...changesetData } = changeset
  const isStandardBranch = branchKey.name === STANDARD_BRANCH
  const localCreationTime = changesetData.creationTime
    ? dateUtils.dateUtcAsLocal(changesetData.creationTime).toDate()
    : undefined

  assertNotEmpty(changesetData.block, translate('error.noBlocks'))

  return (
    <div className={cx('flex gap-x-2 justify-between text-sm', className)}>
      <div className="flex gap-x-2">
        {isStandardBranch ? (
          <StandardBranchStatus server={branchKey.server} />
        ) : (
          <ConfigurationBranchStatus branchKey={branchKey} />
        )}
      </div>
      {!!localCreationTime && (
        <span>{dateUtils.dateWithTimeAsStr(localCreationTime)}</span>
      )}
    </div>
  )
}
